import "./RegisterView.css"
import {postUsers} from "../../../communication/communication";
import {useState} from "react";
import {InitData, useInitData, User} from "@tma.js/sdk-react";
import {WaUser} from "../../../types/farming";
import {useTranslation} from "react-i18next";
import {Button, ButtonProps} from "../Elements/Button";

export type RegisterProps = {
    register: (waUser : WaUser) => void,
    initData: InitData | undefined
    user: string
}

function userToCamelcase(user: User){
    return {
        "id": user.id,
        "is_bot": user.isBot,
        "first_name": user.firstName,
        "last_name": user.lastName,
        "username": user.username,
        "language_code": user.languageCode,
        "is_premium": user.isPremium,
        "added_to_attachment_menu": user.addedToAttachmentMenu,
        "allows_write_to_pm": user.allowsWriteToPm,
        "photo_url": user.photoUrl
    }
}

function retrieveInitDataVitals(initData : InitData) {
    let payload : any = {user: userToCamelcase(initData.user!)}
    if (initData.startParam !== undefined) payload.start_param = initData.startParam
    return JSON.stringify(payload);
}

export function RegisterView({props} : {props : RegisterProps}) {
    const [canRegister, setCanRegister] = useState(true);
    const {t} = useTranslation()
    const initData = useInitData()
     
    const register = () => {
        if (props.initData === undefined || props.initData.user === undefined) {
            setCanRegister(false);
            return;
        }
        
        postUsers(retrieveInitDataVitals(props.initData!)).then(r => {
            if (r.statusCode === 201 || r.statusCode === 200) props.register(r.data!);
            else setCanRegister(false);
        });
    }
    
    const buttonProps: ButtonProps = {
        text: canRegister ? t("letsGo") : t("errorOccurred"),
        onClick: register,
        backgroundColor: "var(--color-main)",
        textColor: canRegister ? "#000000" : "#000000",
    }
    
    // OK
    return (
        <>
            <div className="auth-view">
                <div></div>
                <div className="auth-data">
                    <span className="font-white huge-font fw-400 text-center">{t("welcome")}</span>
                    <span className="font-white huge-font fw-600 text-center arial-rounded">{`${props.user}!`}</span>
                    <br/>
                    <span className="auth-text text-left"> {t("____explytDescription")} </span>
                    <br/>
                    <span className="auth-text text-left"> {t("____lytDescription")} </span>
                </div>
                <div className="small-margin flex-center">
                    <span className="medium-font fw-500 text-center" style={{color: "var(--color-main)"}}>
                        {initData?.startParam ? t("____explytNewUserOfFriendText") : t("____explytNewUserText")}
                    </span>
                </div>
                <div className="register-button flex-center">
                    <Button {...buttonProps}/>
                </div>
            </div>
            <div className="bg-black"/>
        </>
    )
}